module.exports = __webpack_public_path__ + "img/icon-mastercard.525ad027.svg";